<template>
  <div>
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{ name: 'page-user-list' }" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div v-if="!readOnly" class="vx-col w-full flex mb-4" id="account-manage-buttons">
      <vs-button icon-pack="feather" type="border" icon="icon-edit" class="mr-4"
        :to="{ name: 'app-user-edit-broker', params: { userId: $route.params.userId } }">Edit</vs-button>
      <vs-button icon-pack="feather" icon="icon-plus" class="mr-4"
        :to="{ name: 'app-quotation-add-idpers-broker', params: { personId: $route.params.userId } }">Add Quotation</vs-button>
    </div>
    <vs-alert v-if="addressAlert" color="warning" title="Warning" active="true" class="mt-4 mb-4">
      {{ addressAlert }} for the person
      <span>{{ user_data.company_name }}</span>
    </vs-alert>
    <div id="user-data" v-if="user_data">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-full mb-base">
          <vx-card title="Informations" id="page-user-view">
            <div class="vx-row">
              <div class="vx-col flex-1" id="account-info-col-1">
                <table>
                  <!--<tr>
                    <td class="font-semibold">Active</td>
                    <td>
                      <vs-chip v-if="user_data.isactive" color="primary">{{ user_data.isactive }}</vs-chip>
                      <vs-chip v-else color="danger">{{ user_data.isactive }}</vs-chip>
                    </td>
                  </tr>-->
                  <!--<tr>
                    <td class="font-semibold">Type</td>
                    <td>Person</td>
                  </tr>
                  <tr v-if="user_data.isreseller">
                    <td class="font-semibold">Reseller?</td>
                    <td>
                      {{ user_data.isreseller }}
                    </td>
                  </tr>-->
                  <tr>
                    <td class="font-semibold">Name</td>
                    <td>{{ user_data.company_name }}</td>
                  </tr>
                  <tr>
                    <td v-if="dataEmployee.length > 0" class="font-semibold">Employee</td>
                    <td>
                  <tr v-for="(val, id) in dataEmployee" :key="id">
                    <vs-td>
                      <a href="#" @click="ViewEmployee(val.id)">{{ val.name }}</a>
                    </vs-td>
                  </tr>
                  </td>
                  </tr>
                  <tr>
                    <td class="font-semibold">VAT Number</td>
                    <td v-if="user_data.subject_vat">{{ user_data.vat_number }} Applicable</td>
                    <td v-else>{{ user_data.vat_number }} Not Applicable</td>
                  </tr>
                  <tr v-if="user_data.vat_number">
                    <td class="font-semibold">VIES</td>
                    <td>
                      <vs-alert class="w-full" :key="viesBadge.text" :color="viesBadge.color">
                        <feather-icon :icon="viesBadge.icon" svgClasses="h-4 w-4" /> {{ viesBadge.text }}
                      </vs-alert>
                      <span class="text-sm" :class="viesNoteClass" v-if="viesNote">{{ viesNote }}</span>
                    </td>
                  </tr>
                  <tr v-if="user_data.cui">
                    <td class="font-semibold">CUI / CNP</td>
                    <td>{{ user_data.cui }}</td>
                  </tr>
                  <tr v-if="user_data.inmatriculare_j">
                    <td class="font-semibold">Registration Number (J)</td>
                    <td>{{ user_data.inmatriculare_j }}</td>
                  </tr>
                  <tr v-if="user_data.bank_account">
                    <td class="font-semibold">Bank Account</td>
                    <td>{{ user_data.bank_account }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Category</td>
                    <td v-if="this.categoryPerson || user_data.isreseller || user_data.isbroker">
                      <vs-chip color v-if="this.categoryPerson">{{ this.categoryPerson }}</vs-chip>
                      <vs-chip color="primary" v-if="user_data.isreseller">Reseller</vs-chip>
                      <vs-chip color="warning" v-if="user_data.isbroker">Broker</vs-chip>
                    </td>
                    <td v-else>
                      <vs-chip color>not applicable</vs-chip>
                    </td>
                  </tr>
                  <tr v-if="user_data.language">
                    <td class="font-semibold">Language</td>
                    <td>{{ user_data.language.name }}</td>
                  </tr>
                </table>
              </div>
              <div class="vx-col flex-1" id="account-info-col-2">
                <table>
                  <tr v-if="user_data.addresses.length > 0">
                    <td v-if="user_data.iscompany" class="font-semibold">Address</td>
                    <td v-else class="font-semibold">Personal Address</td>
                    <td>
                  <tr v-for="(val, id) in user_data.addresses" :key="id">
                    <vs-td>
                      <u>{{ val.addresscategory.name_en }}</u>
                      <p v-if="val.place.province">
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.province }}),
                        <br />
                        {{ val.place.region }}, {{ val.place.country.name_en }}
                      </p>

                      <p v-else>
                        {{ val.street }} {{ val.number }},
                        <br />
                        {{ val.place.postal_code }} {{ val.place.place_name }} ({{ val.place.region }}),
                        <br />
                        {{ val.place.country.name_en }}
                      </p>
                    </vs-td>
                  </tr>
                  </td>
                  </tr>
                  <tr v-else-if="user_data.billing_address_str">
                    <td class="font-semibold">Address</td>
                    <td>{{ user_data.billing_address_str.substring(0, 70) }}...</td>
                  </tr>
                  <tr v-if="user_data.country_code_str">
                    <td class="font-semibold">Country</td>
                    <td>{{ user_data.country_code_str }}</td>
                  </tr>
                  <tr v-if="user_data.phone">
                    <td class="font-semibold">Phone</td>
                    <td>{{ user_data.phone }}</td>
                  </tr>
                  <tr v-if="user_data.email">
                    <td class="font-semibold">Administrative Email &nbsp;&nbsp;</td>
                    <td>{{ user_data.email }}</td>
                  </tr>
                  <tr v-if="user_data.email_bis">
                    <td class="font-semibold">Transport Email &nbsp;&nbsp;</td>
                    <td>{{ user_data.email_bis }}</td>
                  </tr>
                  <tr v-if="user_data.website">
                    <td class="font-semibold">Website</td>
                    <td>{{ user_data.website }}</td>
                  </tr>
                  <tr v-if="user_data.borker_eshop">
                    <td class="font-semibold">E-shop</td>
                    <td>{{ user_data.borker_eshop }}</td>
                  </tr>
                </table>
              </div>
              <div class="vx-col flex-1" id="account-info-col-3" v-if="markers.length > 0">
                <template>
                  <GmapMap :center="center" :zoom="4" map-type-id="terrain" style="width: 100%; height: 95%">
                    <GmapMarker :key="index" v-for="(m, index) in markers" :position="m" :clickable="true"
                      :draggable="false" @click="center = m" />
                  </GmapMap>
                </template>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2">
        <vx-card title="Details" id="page-user-view">
          <template slot="no-body">
            <table class="mb-base p-8">

              <tr v-if="user_data.client_type">
                <td class="font-semibold">Type</td>
                <td>{{ getClientTypeLabel(user_data.client_type) }}</td>
              </tr>
              <tr v-if="user_data.contactsource">
                <td class="font-semibold">Contact Source</td>
                <td>{{ user_data.contactsource.label }}</td>
              </tr>
              <tr v-if="user_data.idbroker">
                <td class="font-semibold">Broker</td>
                <td>{{ user_data.Broker.company_name }}</td>
              </tr>
              <tr v-if="user_data.ref_price">
                <td class="font-semibold">Price of Ref.</td>
                <td>{{ user_data.ref_price }} EUR/m3</td>
              </tr>
              <tr v-if="user_data.payment_due_day">
                <td class="font-semibold">Payment deadline</td>
                <td>{{ user_data.payment_due_day }} days</td>
              </tr>
              <tr v-if="user_data.product_interest">
                <td class="font-semibold">Interest</td>
                <td>{{ user_data.product_interest }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Sanity Check</td>
                <td v-if="user_data.issanator === true">
                  <p style="color:green">{{ user_data.birthday }} Good</p>
                </td>
                <td v-else-if="user_data.issanator === false">
                  <p style="color:red">{{ user_data.birthday }} Bad</p>
                </td>
                <td v-else>
                  <p style="color:orange">To be Checked</p>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Reliability</td>
                <td @click="keepReliability()">
                  <star-rating :star-size="20" v-model="boundRating"></star-rating>
                </td>
              </tr>
            </table>
          </template>
        </vx-card>
      </div>
      <!--<div class="vx-col w-full lg:w-1/2 mb-8">
        <vx-card title="Chat">
          <template slot="no-body">
            <div class="chat-card-log">
              <component
                :is="scrollbarTag"
                ref="chatLogPS"
                class="scroll-area pt-6 px-6"
                :settings="settings"
                @click="scrollToEnd"
              >
                <ul ref="chatLog">
                  <li
                    class="flex items-start"
                    :class="{'flex-row-reverse': msg.isuserwriter, 'mt-4': index}"
                    v-for="(msg, index) in data_chat"
                    :key="index"
                  >
                    <vs-avatar
                      v-if="msg.isuserwriter"
                      size="60px"
                      class="m-0 flex-shrink-0"
                      :class="msg.isuserwriter ? 'ml-5' : 'mr-5'"
                      :src="msg.avatar"
                    ></vs-avatar>
                    <div
                      class="msg relative bg-white shadow-md py-3 px-4 mb-3 mt-2 rounded-lg max-w-md"
                      :class="{'chat-sent-msg bg-primary-gradient text-white': msg.isuserwriter, 'border border-solid d-theme-border-grey-light': !msg.isuserwriter}"
                    >
                      <span>{{ msg.content }}</span>
                    </div>
                    <small>
                      <small>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ msg.dt }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</small>
                    </small>
                  </li>
                </ul>
              </component>
            </div>
            <div class="flex bg-white chat-input-container p-2 w-full">
              <vs-input
                class="mr-3 w-full"
                v-model="chatMsgPerson"
                @keyup.enter="createChat"
                placeholder="Person Message"
              ></vs-input>
              <vs-input
                class="mr-3 w-full"
                v-model="chatMsgUser"
                @keyup.enter="createChat"
                placeholder="Your Message"
              ></vs-input>
              <vs-button icon-pack="feather" icon="icon-send" @click="createChat"></vs-button>
            </div>
          </template>
        </vx-card>
      </div>-->
    </div>
    <div class="vx-row" v-if="operationLinkedToPerson.length > 0">
      <div class="vx-col w-full">
        <vx-card title="History" class="mb-base">
          <template lang="html">
            <vs-table :data="operationLinkedToPerson">
              <template slot="thead">
                <vs-th>Internal ID</vs-th>
                <vs-th>Date</vs-th>
                <vs-th>Operation</vs-th>
                <vs-th>Product Category</vs-th>
                <vs-th>Volume (m3)</vs-th>
                <vs-th>Ref. Client</vs-th>
                <vs-th>Action</vs-th>
              </template>
              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="data" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].id">#<router-link :to="getLink(tr.id, tr.category.toLowerCase())"
                        class="text-inherit underline">{{ tr.id }}</router-link></vs-td>
                    <vs-td :data="data[indextr].creation">{{ tr.creation }}</vs-td>
                    <vs-td :data="data[indextr].category">{{ tr.category }}</vs-td>
                    <vs-td :data="data[indextr].category_name">{{ tr.category_name }}</vs-td>
                    <vs-td :data="data[indextr].volume">{{ Math.abs(tr.volume).toFixed(4) }}</vs-td>
                    <vs-td :data="data[indextr].ref_client">{{ tr.ref_client }}</vs-td>
                    <vs-td :data="data[indextr].id">

                      <feather-icon icon="EyeIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click="openOperation(tr.id, tr.category.toLowerCase())" />&nbsp;&nbsp;&nbsp;
                      <feather-icon v-if="!readOnly" icon="CopyIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                        @click="copyOperation(tr.id, tr.category.toLowerCase())" />
                    </vs-td>
                  </vs-tr>
                </tbody>
              </template>
            </vs-table>
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import modulePersonList from "@/store/people/modulePersonList.js";
import axios from "@/axios.js";
import { isReadOnlyUser } from "@/helpers/roleAccess.js";
import pricingZones from "@/mixins/pricingZones";
import viesCheck from "@/mixins/viesCheck.js";
import StarRating from "vue-star-rating";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  mixins: [pricingZones, viesCheck],
  components: {
    StarRating,
    VuePerfectScrollbar,
  },
  data() {
    return {
      readOnly: isReadOnlyUser(), // compte en lecture seule (Broker Status) : actions masquées
      user_data: {
        addresses: {},
      },
      user_not_found: false,
      dataEmployee: [],
      categoryPerson: null,
      center: { lat: 50.0, lng: 12.0 },
      markers: [],
      boundRating: 0,

      chatLog: [],
      chatMsgInput: "",
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      data_chat: [],
      chatMsgUser: null,
      chatMsgPerson: null,
      addressAlert: null,
      operationToCopy: null,
      operationTypeToCopy: null,
      operationLinkedToPerson: [
        {
          id: null,
          creation: null,
          category: null,
          category_name: null,
          volume: null,
        },
      ],
    };
  },
  updated() {
    const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS;
    scroll_el.scrollTop = this.$refs.chatLog.scrollHeight;
  },
  mounted() { },
  computed: {
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    getClientTypeLabel(clientType) {
      const m = this.clientTypeMap[clientType];
      return (m && m.label) || clientType;
    },
    getLink(id, operationtype) {
      operationtype = operationtype.replace("einvoice", "outlay").replace("expense", "outlay")
      var val = operationtype.split(" ");
      return "/broker/" + val[0] + "/" + id;
    },
    async getAddressStatus(idperson) {
      axios
        .get("/person/checkaddresses/" + idperson)
        .then((response) => {
          if (response.data.both) {
            this.addressAlert = null;
            return;
          }
          if (response.data.billing === false)
            this.addressAlert = " Missing Billing Address ";
          if (response.data.delivery === false) {
            if (this.addressAlert)
              this.addressAlert =
                this.addressAlert + " and  Missing Delivery Address";
            else this.addressAlert = " Missing Delivery Address";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createChat() {
      let obj = {};
      if (this.chatMsgUser && this.chatMsgPerson) {
        this.$vs.notify({
          color: "danger",
          title: "Two Messages?",
          text: "Please write as Person OR as User",
        });
        return;
      }
      if (!this.chatMsgUser && !this.chatMsgPerson) {
        this.$vs.notify({
          color: "danger",
          title: "No Message?",
          text: "Please write a message before to send!",
        });
        return;
      }
      if (this.chatMsgUser) {
        obj = {
          content: this.chatMsgUser,
          isuserwriter: true,
          iduser: localStorage.getItem("login-id"),
          idperson: this.user_data.id,
        };
      } else if (this.chatMsgPerson) {
        obj = {
          content: this.chatMsgPerson,
          isuserwriter: false,
          iduser: localStorage.getItem("login-id"),
          idperson: this.user_data.id,
        };
      }
      axios
        .post("/person/chat/create", obj)
        .then((response) => {
          this.data_chat = [...response.data];
          this.chatMsgPerson = "";
          this.chatMsgUser = "";
        })
        .catch((error) => {
          reject(error);
        });
    },
    async getChat(idperson) {
      this.$store
        .dispatch("peopleList/getChatMessage", idperson)
        .then((res) => {
          this.data_chat = res.data;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }
          console.error(err);
        });
    },
    scrollToEnd() {
      try {
        const scroll_el = this.$refs.chatLogPS.$el || this.$refs.chatLogPS;
        scroll_el.scrollTop = this.$refs.chatLog.scrollHeight;
      } catch (error) { }
    },
    keepReliability() {
      this.$vs.notify({
        color: "danger",
        title: "Reliability",
        text: "Go to Edit Person to Edit Reliability",
      });
      this.boundRating = this.user_data.reliability;
    },
    async GetAddressPosition() {
      axios
        .get("/getpersonaddressmap/" + this.$route.params.userId)
        .then((response) => {
          this.markers = response.data;
          this.center = response.data[0];
        });
    },
    openOperation(id, operationtype) {
      operationtype = operationtype.replace("einvoice", "outlay").replace("expense", "outlay")
      var val = operationtype.split(" ");
      this.$router.push({ path: "/broker/" + val[0] + "/" + id });
    },
    copyOperation(id, operationtype) {
      var val = operationtype.split(" ");
      this.operationToCopy = id;
      this.operationTypeToCopy = val[0];
      if (this.operationTypeToCopy == "quotation" || this.operationTypeToCopy == "purchase") {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: `You are about to duplicate the  ${val[0]}  ${id}.`,
          accept: this.operationCopying,
          acceptText: 'Duplicate'
        })
      }
      else {
        this.$vs.notify({
          title: "Impossible to Copy",
          text: "Only quotation can be copied!",
          iconPack: "feather",
          icon: "icon-thumbs-down",
          color: "danger",
          position: "bottom-right",
          time: 4000,
        });
      }
    },
    operationCopying() {
      axios
        .get("/operation/duplicate/" + this.operationToCopy)
        .then((response) => {
          this.$router.push({ path: "/broker/" + this.operationTypeToCopy + "/" + response.data.id });
        });
    },
    getOperationsLinkedToPerson() {
      axios
        .get("/operationbyidperson/" + this.user_data.id)
        .then((response) => {
          this.operationLinkedToPerson = response.data;
        });
    },
    getCategoryPerson() {
      axios.get("/categoryperson/" + this.user_data.id).then((response) => {
        this.categoryPerson = response.data.categoryperson;
      });
    },
    getEmployee() {
      if (this.user_data.iscompany) {
        axios
          .get("/people_in_company/data/" + this.user_data.id)
          .then((response) => {
            this.dataEmployee = response.data;
          });
      }
    },
    ViewEmployee(id) {
      window.location.replace("/broker/person/" + id);
    },
    ViewCompany() {
      window.location.replace("/broker/person/" + this.user_data.Company.id);
    },
    getActiveColors(status) {
      if (status === true) return "primary";
      if (status === false) return "danger";
      return "warning";
    },
  },
  created() {
    this.$vs.loading()
    if (localStorage.getItem("login-roles").toLowerCase().includes("accountant")) {
      this.$vs.notify({
        title: "Denied",
        text: "Redirection",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/invoice/invoice-list" })
    }
    if (!modulePersonList.isRegistered) {
      this.$store.registerModule("peopleList", modulePersonList);
      modulePersonList.isRegistered = true;
    }

    const userId = this.$route.params.userId;
    this.getChat(userId);
    this.$store
      .dispatch("peopleList/fetchPersonBroker", userId)
      .then((res) => {
        this.user_data = res.data;
        if (!res.data) {
          this.$vs.notify({
            title: "Denied",
            text: "Redirection",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "bottom-right",
            time: 8000,
          });
          this.$router.push({ path: "/broker/people/people-list" })
        }
        this.getEmployee();
        this.getCategoryPerson();
        this.getOperationsLinkedToPerson();
        this.GetAddressPosition();
        this.getAddressStatus(userId);
        this.checkVies(this.user_data.vat_number)
        this.boundRating = this.user_data.reliability;
        this.$vs.loading.close()
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.user_not_found = true;
          return;
        }
        console.error(err);
      });
  },
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

#avatar-col {
  width: 10rem;
}

/*
#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}*/

@media screen and (min-width: 991px) and (max-width: 1211px),
only screen and (min-width: 0px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  #account-info-col-2 {
    width: calc(100% - 12rem) !important;
  }

  #account-info-col-3 {
    visibility: hidden;
  }
}

/*
.vs-chip-success {
  background: rgba(var(--vs-success), 0.15);
  color: rgba(var(--vs-success), 1) !important;
  font-weight: 500;
}
.vs-chip-warning {
  background: rgba(var(--vs-warning), 0.15);
  color: rgba(var(--vs-warning), 1) !important;
  font-weight: 500;
}
.vs-chip-danger {
  background: rgba(var(--vs-danger), 0.15);
  color: rgba(var(--vs-danger), 1) !important;
  font-weight: 500;
}*/
</style>
